<template>
  <div id="app" :class='{ismobile:ismobile}'>
   
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app',
  data(){
    return{
      domain:'http://www.dkingsh.com/',
      ismobile:true
    }
  },
  watch: {
    '$route' (to, from) {
      this.jump()
      $("html,body").animate({scrollTop:0});
    }
  },
  mounted:function(){
    this.jump()
  },
  methods:{
    jump(){
      var url = window.location.href
      //如果是手机端 ，并且地址不是手机端的地址，转换为手机端地址
      

      if(/Android|webOS|iPhone|iPod|iPad|BlackBerry/i.test(navigator.userAgent)&&(url.indexOf('#/m/')<0)){
        this.ismobile=true
        if(window.location.href.indexOf('product')>0){
          this.$router.push('/m/product')
        }else{
          window.location.href=window.location.href.replace('#/','#/m/')
        }
      }
      //如果是手机端 ，并且地址是手机端的地址
      if(/Android|webOS|iPhone|iPod|iPad|BlackBerry/i.test(navigator.userAgent)&&(url.indexOf('#/m/')>0)){
        this.ismobile=true
        return false;
      }


      //如果是非移动端 ，并且地址是手机端的地址
      if(!/Android|webOS|iPhone|iPod|iPad|BlackBerry/i.test(navigator.userAgent)&&(url.indexOf('#/m/')>0)){
        this.ismobile=false
        //如果是非手机端登录，地址中包含手机地址，跳转到PC端
        if(window.location.href.indexOf('product')>0){
          this.$router.push('/product')
        }else{
          window.location.href=window.location.href.replace('#/m/','#/')
        }
      }
     //如果是非移动端 ，并且地址是非移动端
      if(!/Android|webOS|iPhone|iPod|iPad|BlackBerry/i.test(navigator.userAgent)&&(url.indexOf('#/m/')<0)){
        this.ismobile=false
        return false;
      }
    }
  }
}
</script>
<style>
	*{
		font-family:'Microsoft YaHei' !important;
	}
  input:focus{
    outline: none !important;
  }
  input{
    border: none;
  }
  .detail_content .p_content{
    text-align: center;
  }
  @media screen and (max-width: 640px){
    body{
      width: 6.4rem;
      margin: 0 auto;
    }
    #app{
      overflow:hidden;
    }
  }
  .ismobile{
      width: 6.4rem;
      margin:0 auto;
      position: relative;
      overflow-x: hidden;
      padding-bottom: 0.6rem;
  }
  .cases_detail_content{
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue